import React from "react";
import { Box } from "@mui/material";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";
import { EmptyState } from "./helpers/StatePrimitives";

function NotFoundPage() {
  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <EmptyState
        icon={<SearchOffOutlinedIcon />}
        title="Page not found"
        description="The page you are looking for does not exist or may have moved."
      />
    </Box>
  );
}

export default NotFoundPage;
